import {
  Foreground
} from "./chunk-GJG3O4FA.mjs";
import {
  trackNonIdleActivity
} from "./chunk-EGFZ6VYA.mjs";
import {
  initializeContext
} from "./chunk-PQQKXVNG.mjs";
import {
  initializeAnalyticsDatastore
} from "./chunk-QA33IEUY.mjs";
import {
  setupListeners
} from "./chunk-HMU5CZV3.mjs";
import {
  sendEvents
} from "./chunk-56HYCTGH.mjs";

// src/initializers/initialize.ts
function initialize(config, callback) {
  initializeAnalyticsDatastore(config);
  initializeContext({
    initializedCallback: async () => {
      if (callback) {
        callback();
      }
      if (!config.disableDefaultForegroundEvent) {
        Foreground.fire({
          contentType: "none",
          /**
           * In mobile land referrer is the link you used to launch the app (deeplink, notification, etc).
           * In web land its the site you were on before.
           * What we want ExternalReferrerUri to mean cross platform is what link did you click on to
           * "launch" our app. For web that's window.location.href.
           * This is so that we can pull out UTM parameters for comms link tracking.
           */
          externalReferrerUri: window.location.href,
          source: "link"
        });
      }
      if (!config.disableDefaultNonIdleTracking) {
        trackNonIdleActivity();
      }
    },
    readyCallback: sendEvents
  }).then(() => {
    if (!config.disableDefaultListeners) {
      setupListeners();
    }
  });
}

export {
  initialize
};
